import React from 'react'
import { Link } from 'react-router-dom'
import RusPatent from '../../Banner/RusPatent'

type Props = {
    className?: string
}

export const MenuPatentLink: React.FC<Props> = ({ className }) => {
    return (
        <Link
            to="https://fips.ru/registers-doc-view/fips_servlet?DB=EVM&DocNumber=2024683593"
            target="_blank"
            rel="noopener noreferrer"
            className={`group flex-row items-center justify-start gap-1 ${className}`}
        >
            <div className="w-12 h-10">
                <RusPatent />
            </div>

            <div className="text-[12px] leading-none text-nowrap">
                <span className=" text-[#0a2b78] text-[12px]  font-semibold ">
                    Зарегистрированное ПО
                </span>
                <br />
                <span className=" text-[#666666]  group-hover:text-[#38bdf8] transition-colors duration-200">
                    Номер регистрации №2024683593
                </span>
            </div>
        </Link>
    )
}
